import React from 'react'
import styled from 'styled-components'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'
import { Card as CardBase, CardImg, CardBody, Button } from 'reactstrap'
import thumbnailNotAvailable from 'img/image-not-available.png'
import { isMobile } from 'react-device-detect'
import parse from 'react-html-parser'
import Rating from 'ui/rating'

const Wrapper = styled.div.attrs({
  className: 'card-wrapper p-2'
})`
  max-width: 300px;
`

const Card = styled(CardBase)`
  transition: 1s;
`

const Badge = styled.div.attrs({
  className: 'px-2 shadow rounded'
})`
  position: absolute;
  top: 0em;
  left: 0em;
  opacity: 1;
  z-index: 1;
  font-weight: bold;
  border-top-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
`

const BestSellerBadge = styled(Badge).attrs({
  className: 'text-white bg-success'
})``

const Thumbnail = styled(CardImg).attrs({
  className: ''
})`
  ${props => props.status === 'active' && `
    cursor: pointer;
    transition: 0.3s;
    opacity: 0.88;

    &:hover {
      opacity: 1;
    }
  `}

  ${props => props.status != 'active' &&`
    cursor: default;
    filter: grayscale(100%);
    opacity: 0.8;
  `}  
`

const ProductTitle = styled.h2.attrs({
  className: 'mb-2'
})`
  font-size: 1.3rem;
  font-weight: bold;

  a {
    text-decoration: none;
    color: var(--bs-secondary);
    transition: .5s ease;

    &:hover {
      color: var(--bs-primary);
    }
  }
`

const FeaturedPrice = styled.span`
  cursor: pointer;
  transition: .3s ease;
  border: 0;
  border-radius: 0.15em;

  strong {
    font-size: 1.15em;
  }

  &:hover {
    color: var(--bs-primary);
  }
`

const CallAction = styled.a.attrs({
  className: 'text-primary fw-bold'
})`
  font-size: 1.25em;
`

const Hooks = ({ hooks }) => {
  const { i18n } = useTranslation()
  const hooksArray = JSON.parse(hooks || null)

  if (!hooksArray || hooksArray.length < 1) return ''

  return (
    <ul className="d-flex flex-column flex-md-row list-unstyled m-0 p-0">
      {hooksArray.map((item, index) => (
        <li key={index} className="me-3">
          <i className="fa fa-check text-primary me-1 mb-1 mb-md-0" />{parse(item)}
        </li>
      ))}
    </ul>
  )
}

const ProductCard = (props) => {
  const {
    id, excerpt, thumbnail, cover_small, title, status, featured_price,
    featured_price_label, rating, hooks, url, best_seller, newWindow
  } = props
  const { i18n } = useTranslation()

  return (
    <Card className="h-100 d-flex flex-column flex-md-row border-0 mx-4 mx-md-0">
      {best_seller &&
        <BestSellerBadge>{i18n.t('product_card.best_seller_badge')}</BestSellerBadge>
      }

      <div
        style={{ flex: isMobile ? 'auto' : '0 0 30%', cursor: 'pointer' }}
        className="me-md-4 mb-3 mb-md-0"
        onClick={() => {
          if (status !== 'active') return

          newWindow ? window.open(url) : window.location.href = url
        }}
      >
        <Thumbnail
          className="rounded-4"
          top
          width="100%"
          height="100%"
          style={{objectFit: 'cover'}}
          status={status}
          alt={title}
          src={cover_small || thumbnailNotAvailable}
        />
      </div>
      <div style={{ flex: isMobile ? 'auto' : '0 0 70%' }}>
        <CardBody className="h-100 px-4 py-3 d-flex flex-column align-items-start border rounded-4">
          <div className="p-1">
            <div className="mb-2">
              <Rating value={rating} />
            </div>

            <ProductTitle>
              <a href={status == 'active' ? url : '#'} target={newWindow ? 'blank' : '_self'}>{title}</a>
            </ProductTitle>
            <div>{excerpt}</div>
            <div className="my-2">
              <Hooks hooks={hooks} />
            </div>
          </div>
          <div className="mt-auto w-100">
            <hr />
            <div className="d-flex justify-content-between align-items-center">
              <div className="text-primary">
                {featured_price &&
                  <FeaturedPrice onClick={() => newWindow ? window.open(url) : window.location.href = url}>
                    {i18n.t('product_card.from')} <strong className="h3">{featured_price_label}</strong>
                  </FeaturedPrice>
                }
              </div>
              <CallAction className="card-call-action" href={url}>
                {i18n.t('format:actions.book_now')} <i className="fa fa-arrow-right" />
              </CallAction>
            </div>
          </div>
        </CardBody>
      </div>
    </Card>
  )
}

export default ProductCard
